import React from 'react';
import {FormattedHTMLMessage, useIntl} from 'react-intl';
import GenericModal from '../../../../../containers/modal/generic_modal';
import ForecastQueryRenderer from '../../../../../ForecastQueryRenderer';
import ReportedTimeCSVModal, {ReportedTimeCSVModalQuery} from './ReportedTimeCSVModal';

const ReportedTimeCSVModalWrapper = ({closeModal, searchQuery, enabledColumns, validateAccess = false}) => {
	const intl = useIntl();

	const content = (
		<div className={'body-container'}>
			<div style={{marginBottom: '12px'}}>{intl.formatMessage({id: 'common.wait_gathering'})}</div>
			<ForecastQueryRenderer
				key="query-render-ReportedTimeCSVModal"
				componentName="reported_time_CSV"
				query={ReportedTimeCSVModalQuery}
				modal={true}
				showLoader={false}
				variables={{
					pageSize: 50000,
					searchQuery: searchQuery,
					validateAccess: validateAccess,
				}}
				render={relayProps => {
					return <ReportedTimeCSVModal {...relayProps} enabledColumns={enabledColumns} closeModal={closeModal} />;
				}}
			/>
		</div>
	);
	return (
		<GenericModal
			closeModal={closeModal}
			headerText={<FormattedHTMLMessage id="common.processing_loading" />}
			content={content}
			preventClickAwayClose={true}
			modalWidth={572}
		/>
	);
};

export default ReportedTimeCSVModalWrapper;
